import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import { listFlags } from "../../api/admin";
import { COMPANIES_KEY } from "../companies/queries";

export const MODERATION_KEY = ["admin", "moderation"] as const;
export const flagsKey = (state: "open" | "resolved") => [...MODERATION_KEY, "flags", state] as const;
export const REVIEW_KEY = [...MODERATION_KEY, "review"] as const;
export const AUDIT_KEY = [...MODERATION_KEY, "audit"] as const;

/** Open flags; also feeds the badge next to "Moderatie" in the sidebar. */
export function useOpenFlags(enabled = true) {
  return useQuery({ queryKey: flagsKey("open"), queryFn: () => listFlags("open"), enabled });
}

/** After a moderation action: queue, review list, audit log and every company view. */
export function useRefreshModeration() {
  const client = useQueryClient();
  return useCallback(() => {
    void client.invalidateQueries({ queryKey: MODERATION_KEY });
    void client.invalidateQueries({ queryKey: COMPANIES_KEY });
  }, [client]);
}
